export function formatDate(dateString) {
  const date = new Date(dateString);
  const options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-GB', options);

  // Add ordinal suffix to the day
  const day = date.getDate();
  const ordinalSuffix = (day) => {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  return formattedDate.replace(/\d+/, `${day}${ordinalSuffix(day)}`);
} 

export function formatTime(time, status = null) {
    if (!time) return '';
    
    // Check if match status is TBC or time is 00:00:00/00:00
    if (status === 'TBC' || time === '00:00:00' || time === '00:00') {
        return 'TBC';
    }
    
    // Convert to 12-hour format with AM/PM
    const [hours, minutes] = time.split(':');
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    const formattedTime = `${hour12}:${minutes} ${ampm}`;
    
    return formattedTime;
}

export const formatTimeRange = (startTime, duration) => {
    if (!startTime) return '';
    
    let hours, minutes;
    
    // Check if the time is already formatted (contains AM/PM)
    if (startTime.includes('AM') || startTime.includes('PM')) {
        // Parse already formatted time (e.g., "6:30 PM")
        const timeMatch = startTime.match(/(\d+):(\d+)\s*(AM|PM)/i);
        if (timeMatch) {
            hours = parseInt(timeMatch[1]);
            minutes = parseInt(timeMatch[2]);
            const ampm = timeMatch[3].toUpperCase();
            
            // Convert to 24-hour format
            if (ampm === 'PM' && hours !== 12) {
                hours += 12;
            } else if (ampm === 'AM' && hours === 12) {
                hours = 0;
            }
        } else {
            return startTime; // Return as-is if we can't parse it
        }
    } else {
        // Parse 24-hour format time (e.g., "18:30")
        [hours, minutes] = startTime.split(':').map(Number);
    }
    
    const start = new Date();
    start.setHours(hours, minutes, 0);
    
    // Calculate end time by adding duration minutes
    const end = new Date(start);
    end.setMinutes(end.getMinutes() + parseInt(duration || 60));
    
    // Format both times with AM/PM
    const formatTimeWithAMPM = (date) => {
        const hour = date.getHours();
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12;
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hour12}:${minutes} ${ampm}`;
    };
    
    const startFormatted = formatTimeWithAMPM(start);
    const endFormatted = formatTimeWithAMPM(end);
    
    return `${startFormatted} - ${endFormatted}`;
};